import { PendingTemplatesComponent } from "@/components/pending";
import { QueryBoundary } from "@/components/query-boundary";
import { TemplateTable } from "@/components/template/template-table";
import { zodSlug } from "@papier/shared";
import { createFileRoute } from "@tanstack/react-router";
import { LayoutDashboard } from "lucide-react";
import { z } from "zod";

const indexSearchSchema = z.object({
  env: zodSlug().optional(),
});

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/")({
  component: IndexProjectTemplates,
  validateSearch: indexSearchSchema,
});

function IndexProjectTemplates() {
  return (
    <main className="grid gap-6">
      <div className="flex items-center gap-2 text-xl font-semibold">
        <LayoutDashboard className="size-5" />
        Templates
      </div>
      <QueryBoundary suspenseFallback={<PendingTemplatesComponent />}>
        <TemplateTable />
      </QueryBoundary>
    </main>
  );
}
